module.exports = __webpack_public_path__ + "img/From-Concept-to-Launch_-Building-a-Product-with-AI-Assistance-scaled.0481faed.jpg";